import React, { useState, useEffect, useRef } from "react";
import { Navigate, useLocation, useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import "../../admin_tools.css";
import { Button } from "@progress/kendo-react-buttons";
import BackIcon from "../../../../assets/communication/Back.svg";
import { ADMIN_TOOLS_MATTER_LIST } from "../../../../routes";
import EditIcon from "../../../../assets/common/edit_icon.svg";
import ArrorRightIcon from "../../../../assets/common/arrao-right.svg";
import { Loader } from "@progress/kendo-react-indicators";
import { fetchMatterById, updateMatter } from "../../../../store/matter";
import { MatterForm } from "./matter_form";


import {
    getUserPermission,
    checkMultiPermission,
    ADMIN_TOOLS_ADD_EDIT_MATTER,
  } from "../../../../config/permission_helper";
  
  const shouldShowEdit = () => {
    const userPermissions = getUserPermission();
    if (checkMultiPermission(userPermissions, ADMIN_TOOLS_ADD_EDIT_MATTER)) {
        console.log('RETURN TRUE');
      return true;
    } else {
        console.log('RETURN False');
      return false;
    }
  };

export const MatterDetails = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    let { search } = useLocation();
    const query = new URLSearchParams(search);
    const matter_id = query.get("id");
    const [isEdit, setIsEdit] = useState(false);
    const [loading, setLoading] = useState(false);
    const {
        detail_data,
        detail_loading,
        detail_error,
    } = useSelector((state) => state.matter);
    
    useEffect(() => {
        console.log(1234);
        if (matter_id) {
            dispatch(fetchMatterById(matter_id));
        }
    }, [])
    const handleSaveMatter = (data) => {
        data.id = matter_id
        console.log('Handle Save Matter--',data);
        dispatch(updateMatter({ data, matter_id }))
            .then(() => {
                setIsEdit(false);
                dispatch(fetchMatterById(matter_id));
            });
    }
    return (
        <>
            <div className="detail-body">
                {detail_loading ? (
                    <Loader
                        type="infinite-spinner"
                        style={{
                            display: "flex",
                            alignItems: "center",
                            width: "40px",
                            margin: "auto",
                            justifyContent: "center",
                            height: "100vh",
                        }}
                    />
                ) : (
                    <>
                        <div className="detail-header">
                            <div className="categoryback-group-div" onClick={() => navigate(ADMIN_TOOLS_MATTER_LIST)}>
                                <img src={BackIcon} className="categoryback-icon" />
                                <span className="categoryback-label">Back</span>
                            </div>
                            <div>
                            { shouldShowEdit() && (
                               <div>
                                    {!isEdit && (
                                    <div>
                                        <Button className="editBtn" onClick={() => setIsEdit(true)}>
                                            <img src={EditIcon} style={{ verticalAlign: "middle" }} />
                                            <span className="editBtn-label">Edit</span>
                                            <img src={ArrorRightIcon} style={{ verticalAlign: "middle" }} />
                                        </Button>
                                    </div>

                                )}
                               </div>
                            )}
                            {/* {!isEdit && (
                                    <div>
                                        <Button className="editBtn" onClick={() => setIsEdit(true)}>
                                            <img src={EditIcon} style={{ verticalAlign: "middle" }} />
                                            <span className="editBtn-label">Edit</span>
                                            <img src={ArrorRightIcon} style={{ verticalAlign: "middle" }} />
                                        </Button>
                                    </div>

                                )} */}
                            </div>
                        </div>
                        <div className="detail-content">
                            <MatterForm
                                data={detail_data}
                                setIsEdit={setIsEdit}
                                isEdit={isEdit}
                                submitForm={handleSaveMatter}
                            />
                        </div>
                    </>
                )}

            </div>
        </>

    );
};